/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-22 18:22:07
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-05-27 16:54:45
 * @FilePath: /unifyxp-v2-store-portal/src/pages/FileDetail/index.tsx
 */
import { getI18nFromGeneral } from '@/src/tools/tools';
import {
  Breadcrumb,
  Button,
  Input,
  SectionCollapse,
  SizeFittingTable,
  Tag,
} from '@/src/components/Antd';
import Warning from '@/src/components/Antd/Modal/WarningModal';
import RouteBlock from '@/src/constrains/RouterBlock/RouterBlock';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import { Icon } from '@/src/tools/icon';
import {
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
  EPermissionSource,
} from '@/src/types/common/resources';
import { Popover } from 'antd';
import _ from 'lodash';
import React from 'react';
import { useHistory, useParams } from 'react-router';
import { EditInput, InstanceModal } from './Components';
import { breadcrumbData } from './config';
import useModalService from './modal.service';
import useService from './service';
import styles from './style.module.less';
import useTagService from './tag.service';
import { getInfoFromFile } from './util';
import useWarnningService from './warnning.service';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
function FileDetail() {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const fileInfoConfig = [
    {
      infoProp: 'originalName',
      infoName: getI18n('storeFileLibrary.detail.fileName'),
    },
    {
      infoProp: 'originalName',
      infoName: getI18n('storeFileLibrary.detail.fileType'),
    },
    {
      infoProp: 'size',
      infoName: getI18n('storeFileLibrary.detail.fileSize'),
    },
    {
      infoProp: ['width', 'height'],
      infoName: getI18n('storeFileLibrary.detail.dimension'),
    },
    {
      infoProp: 'createdDate',
      infoName: getI18n('storeFileLibrary.detail.uploadedat'),
    },
    {
      infoProp: 'url',
      infoName: getI18n('storeFileLibrary.detail.uRL'),
    },
  ];

  const canUpload = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsFileLibrary,
        operation: EnumOperation.upload_and_edit_file,
      }),
    ],
  });
  const canDelete = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsFileLibrary,
        operation: EnumOperation.delete_file,
      }),
    ],
  });

  const history = useHistory();
  const { uuid } = useParams<{ uuid: string }>();
  const {
    file,
    copy,
    saved,
    handleDeleteTag,
    handleChangeOriginalName,
    handleAddTag,
    handleDelete,
    handleSubmit,
  } = useService(uuid);
  const inputProp = useTagService();
  const { visible, onCancel, handleCheckDetail, instance } = useModalService();
  const { deleteModalVisible, setDeleteVisible } = useWarnningService();

  const handleClickBack = () => {
    history.push(`/settings/fileLibrary`);
  };

  const handleSuccessDelete = () => {
    handleDelete(uuid);
    setDeleteVisible(false);
    setTimeout(
      () => history.push(`/settings/fileLibrary`, { skipNotice: true }),
      1000,
    );
  };

  const columns = [
    {
      title: getI18n('storeFileLibrary.detail.instanceName'),
      dataIndex: 'instanceName',
      default: true,
      minWidth: 280,
    },
    {
      title: getI18n('storeFileLibrary.detail.altText'),
      dataIndex: 'altText',
      default: true,
      minWidth: 162,
    },
    {
      title: getI18n('storeFileLibrary.detail.instanceLocation'),
      dataIndex: 'loc',
      default: true,
      minWidth: 472,
    },
    {
      title: getI18n(
        'general.advancedFilters.commonStoreProductsWithTable.actions',
      ),
      minWidth: 47,
      default: true,
      childGenerate: (text, record) => {
        return (
          <span
            className={styles.ahref}
            onClick={handleCheckDetail.bind(this, record)}>
            {getI18n('general.details')}
          </span>
        );
      },
    },
  ];

  const renderHeader = () => {
    return (
      <div className={styles.header}>
        <div className={styles.left}>
          <Button icon={<Icon type='iconleft' />} onClick={handleClickBack}>
            {getI18n('general.back')}
          </Button>
          <Breadcrumb
            className={styles.breadcrumb}
            breadcrumbData={breadcrumbData({ getI18n })}
          />
        </div>
        <div className={styles.right}>
          <span className={styles.change}>
            {saved
              ? getI18n('general.savedchanges')
              : getI18n('general.unsavedchanges')}
          </span>
          <Button
            className={styles.middleBtn}
            type='danger'
            ghost
            icon={<Icon type='icondelete' />}
            disabled={!canDelete}
            onClick={() => setDeleteVisible(true)}>
            {getI18n('general.delete')}
          </Button>
          <Button type='primary' onClick={handleSubmit} disabled={!canUpload}>
            {getI18n('general.save')}
          </Button>
        </div>
      </div>
    );
  };

  const renderContent = () => {
    return (
      <div className={styles.content}>
        <div className={styles.image}>
          <div className={styles.title}>{file.originalName}</div>
          <div
            className={styles.img}
            style={{ backgroundImage: `url('${file.url}')` }}></div>
        </div>
        <SectionCollapse
          open={true}
          id={'fileInfomation'}
          titleStyle={{ height: '64px', marginTop: '16px' }}
          title={
            <div className={'collapseTitle'}>
              {getI18n('storeFileLibrary.detail.fileInformation')}
            </div>
          }
          content={renderFileInfoContent()}
          openMargin={16}
        />

        <SectionCollapse
          open={true}
          id={'fileTags'}
          titleStyle={{ height: '64px' }}
          title={
            <div className={'collapseTitle'}>
              {' '}
              {getI18n('storeFileLibrary.detail.fileTags')}
            </div>
          }
          content={renderFileTagsContent()}
          openMargin={16}
        />

        <SectionCollapse
          open={true}
          id={'fileInstances'}
          titleStyle={{ height: '64px' }}
          title={
            <div className={'collapseTitle'}>
              <span className={styles.instaneHeader}>
                {' '}
                {getI18n('storeFileLibrary.detail.fileInstances')}
              </span>
              <Popover
                placement={'right'}
                title={null}
                content={
                  <>
                    <div className={styles.title}>
                      {' '}
                      {getI18n('storeFileLibrary.detail.fileInstances')}
                    </div>
                    <div>{getI18n('storeFileLibrary.detail.instanceTip')}</div>
                  </>
                }>
                <Icon type='icontooltip' className={styles.icon} />
              </Popover>
            </div>
          }
          content={renderFileInstancesContent()}
          openMargin={16}
        />
      </div>
    );
  };

  const renderFileInfoContent = () => {
    return (
      <div className={styles.fileInfoContent}>
        {fileInfoConfig.map((config) => {
          return (
            <Info
              key={config.infoName}
              title={config.infoName}
              info={
                config.infoName === 'File Name'
                  ? renderInput()
                  : getInfoFromFile(config.infoName, config.infoProp, file)
              }
            />
          );
        })}
      </div>
    );
  };

  const renderFileTagsContent = () => {
    const tags = file.tags || [];
    return (
      <div className={styles.fileTagContent}>
        <div className={styles.fileTagTitle}>
          <span className={styles.bold}>{getI18n('general.tags')}</span>
          <span>{getI18n('storeFileLibrary.detail.pressentertoaddtag')}</span>
        </div>
        <div className={styles.fileTagInput}>
          <Input
            {...inputProp}
            className={styles.input}
            placeholder={'Add a new tag'}
            onPressEnter={() => {
              handleAddTag(inputProp.value);
              inputProp.onChange('');
            }}
          />
        </div>
        <div className={styles.tags}>
          {tags.map((tag) => {
            return (
              <Tag
                key={tag.uuid}
                closable
                onClose={handleDeleteTag.bind(this, tag)}>
                {tag.name}
              </Tag>
            );
          })}
        </div>
      </div>
    );
  };

  const renderFileInstancesContent = () => {
    return (
      <div className={styles.fileInstancesContent}>
        <div className={styles.head}>
          {getI18n('storeFileLibrary.detail.6Instance')}
        </div>
        <div className={styles.table}>
          <SizeFittingTable
            rowKey='uuid'
            rowClassName={styles.row}
            pagination={false}
            id='fileInstancesTable'
            columns={columns}
            dataSource={file.instances}
          />
          <InstanceModal
            visible={visible}
            onCancel={onCancel}
            instance={instance}
          />
        </div>
      </div>
    );
  };

  const renderInput = () => {
    return (
      <EditInput
        value={
          file.originalName
            ? file.originalName.substring(0, file.originalName.lastIndexOf('.'))
            : ''
        }
        onChange={handleChangeOriginalName}
      />
    );
  };
  return (
    <div className={styles.container}>
      {renderHeader()}
      {renderContent()}
      <RouteBlock
        onConfirm={(f) => f()}
        okText={getI18nFromGeneral('general.commonHeader.discard_text')}
        active={!_.isEqual(copy, file) && !saved}
        title={getI18nFromGeneral('general.commonHeader.discard_header')}
        content={getI18nFromGeneral('general.commonHeader.leave_content')}
      />
      <Warning
        visible={deleteModalVisible}
        header='Delete file'
        onOk={handleSuccessDelete}
        okText={'Delete'}
        cancelText={getI18n('general.cancel')}
        onCancel={() => setDeleteVisible(false)}>
        This file is about to be permanently deleted. Do you still want to
        continue?
      </Warning>
    </div>
  );
}

export default FileDetail;

const Info = ({ title, info }) => {
  return (
    <div className={styles.info}>
      <div className={styles.infoTitle}>{title}</div>
      <div className={styles.infoName}>{info}</div>
    </div>
  );
};
